import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import PractitionerSessions from "@app/components/renderings/UserSessions/components/PractitionerSessions/PractitionerSessions";
import SeekerSessions from "@app/components/renderings/UserSessions/components/SeekerSessions/SeekerSessions";
import {
  PermissionEnum,
  usePermissions,
} from "@app/features/permissions/permissions";
import { RootState } from "@app/redux/root-reducer";

import NoSessions from "../NoSessions/NoSessions";
import styles from "./UpcomingSessions.module.scss";
import { getUser } from "@app/features/auth/redux/auth.slice";

const UpcomingSessions = () => {
  const { t } = useTranslation();
  const { allowed } = usePermissions([PermissionEnum.PRACTITIONERS_DASHBOARD]);
  const { classes, teachings, loading } = useSelector(
    (state: RootState) => state.classes
  );

  const { user } = useSelector(
    (state:RootState) => state.auth
  )

  const hasResults = () => {
    return !![...classes, ...teachings].length;
  };

  console.log(user)

  return (
    <>
      {allowed && (
        <PractitionerSessions
          title={t("myBookings.sessionsTeaching")}
          className={styles.section}
          showAttendeesModal
          showPagination
        />
      )}
      <SeekerSessions
        hideCTA
        smallOnMobile={false}
        title={allowed ? t("myBookings.sessionsForMe") : undefined}
        className={styles.section}
        allowCancel
        showPagination
        includeCancelled
      />
      {!hasResults() && !loading && (
        <NoSessions title={t("myBookings.noSessionsTitle")} />
      )}
    </>
  );
};

export default UpcomingSessions;
